import { Dispatch, RefObject, useLayoutEffect } from "react";
import { useAnchoredPosition } from "components/designV2/useAnchoredPosition";
import type {
  DatePickerMenuAlignment,
  DatePickerTrigger,
} from "./datePicker.types";
import type { DatePickerAction } from "./useDatePickerState";

const VERTICAL_OFFSET_PX = 8;

interface UseDatePickerPositioningParams {
  readonly buttonTriggerRef: RefObject<HTMLDivElement>;
  readonly dispatch: Dispatch<DatePickerAction>;
  readonly isOpen: boolean;
  readonly menuAlignment?: DatePickerMenuAlignment;
  readonly popupRef: RefObject<HTMLDivElement>;
  readonly trigger: DatePickerTrigger;
  readonly triggerRef: RefObject<HTMLInputElement>;
}

export function useDatePickerPositioning(
  props: UseDatePickerPositioningParams,
): void {
  const dispatch = props.dispatch;
  const isOpen = props.isOpen;
  const activeTriggerRef =
    props.trigger === "button" ? props.buttonTriggerRef : props.triggerRef;
  const position = useAnchoredPosition({
    anchor: "parent",
    floatingRef: props.popupRef,
    gap: VERTICAL_OFFSET_PX,
    isOpen,
    placement: props.menuAlignment === "right" ? "end" : "start",
    triggerRef: activeTriggerRef,
    widthMode: "content",
  });

  useLayoutEffect(() => {
    if (!isOpen || !position) return;
    dispatch({ type: "set-menu-position", menuPosition: position });
  }, [dispatch, isOpen, position]);
}
